import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';

const WhatsAppFloat = () => {
  const handleClick = () => {
    const message = encodeURIComponent("Hi! I'm interested in your Islamic calligraphy artworks.");
    window.open(`https://wa.me/919381690689?text=${message}`, '_blank');
  };

  return (
    <motion.button
      className="whatsapp-float"
      onClick={handleClick}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 2, type: "spring" }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      aria-label="Contact on WhatsApp"
      data-testid="whatsapp-float-btn"
    >
      <MessageCircle size={28} color="white" />
      
      {/* Pulse Animation */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
    </motion.button>
  );
};

export default WhatsAppFloat;
